import { LegalLinks } from '../../components/LegalLinks';
import { AuthForm, type AuthMode } from './AuthForm';
import { BrandPanel } from './BrandPanel';
import styles from './SignInPage.module.css';

export const STRAVA_ERROR = 'Strava sign-in didn’t complete. Try again or use email.';

export function SignInPage({ mode, error }: { mode: AuthMode; error?: 'strava' }) {
  return (
    <div className={styles.page}>
      <BrandPanel />
      <main className={styles.formSide}>
        <AuthForm key={mode} mode={mode} initialError={error === 'strava' ? STRAVA_ERROR : null} />
        <LegalLinks newTab />
      </main>
    </div>
  );
}
